import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProposalService } from '../../service/proposal.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from "ng2-bootstrap-modal";
import { ProposalViewModalComponent } from '../../../account-client/component/account-client-details/proposal-view-modal/proposal-view-modal.component';
import { filter } from 'rxjs/operator/filter';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { IMyDpOptions } from 'mydatepicker';

@Component({
	selector: 'app-proposal',
	templateUrl: './proposal.component.html',
	styleUrls: ['./proposal.component.scss'],
	providers: [ProposalService]
})

export class ProposalComponent implements OnInit {
	private token;

	clientTypes: any[];
	segmentTypes: any[];
	statusTypes: any[];
	gcs: any[];
	directors: any[];
	filter: any[];
	resultados: any[];
	total: any;
	analysts: any[];
	ctcs: any[];
	ctcObj: string;
	currentPage: number = 0;

	public orderby: string = "TipoProposta";
	public sort: string = "asc";

	private today = moment();
	private permissoes;
	private tempGroup: any[] = [];

	public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
//	public cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
	public cnpjMask = [/\w/, /\w/, '.',/\w/, /\w/, /\w/, '.',/\w/, /\w/, /\w/, '/',/\w/, /\w/, /\w/, /\w/, '-',/\w/, /\w/];
	//Option to datepicker
	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.year(), month: this.today.month()+1, day: this.today.date()},
		//disableUntil: { year: this.today.year(), month: this.today.month() + 1, day: this.today.date() },
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		//height: "30px"
	};

	constructor(private proposalservice: ProposalService,
		private fb: FormBuilder,
		private flashMessagesService: FlashMessagesService,
		private router: Router,
		private dialogService: DialogService,
		private route: ActivatedRoute) {

		this.token = localStorage.getItem('yara.token');

		this.proposal = this.fb.group({
			'TipoProposta': '',
			'CodigoProposta': '',
			'Cliente': '',
			'Status': '',
			'ValorProposta': '',
			'Vigencia': '',
			'VigenciaFim': '',
			'Rating': '',
			'TipoCliente': '',
			'Segmento': '',
			'CTC': '',
			'GC': '',
			'Diretoria': '',
			'DataCriacao': '',
			'DataCriacaoFim': '',
			'DataConclusao': '',
			'DataConclusaoFim': '',
			'DataEntrega': '',
			'DataEntregaFim': '',
			'Analista': '',
			'Documento': '',
			'LeadTime': '',
			'LeadTimeFim': ''
		});
	}

	proposal: FormGroup;

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.ClientTypes();
		this.SegmentTypes();
		this.getStatus();
		this.getCTC();
		this.getGC();
		this.getDirector();
		this.getAnalyst();
	}

	clearFields(){
		this.proposal = this.fb.group({
			'TipoProposta': '',
			'CodigoProposta': '',
			'Cliente': '',
			'Status': '',
			'ValorProposta': '',
			'Vigencia': '',
			'VigenciaFim': '',
			'Rating': '',
			'TipoCliente': '',
			'Segmento': '',
			'CTC': '',
			'GC': '',
			'Diretoria': '',
			'DataCriacao': '',
			'DataCriacaoFim': '',
			'DataConclusao': '',
			'DataConclusaoFim': '',
			'DataEntrega': '',
			'DataEntregaFim': '',
			'Analista': '',
			'Documento': '',
			'LeadTime': '',
			'LeadTimeFim': ''
		});
	}

mask(): any {
  return {
    mask: (value: string) => {

      // ✅ Se houver QUALQUER letra, já é CNPJ
      if (/[a-zA-Z]/.test(value)) {
        return this.cnpjMask;
      }

      // ✅ Usa somente números para decidir CPF x CNPJ
      const numericValue = value.replace(/[^a-zA-Z0-9]+/g, '');

      // CPF → apenas números
      if (numericValue.length < 12) {
        return this.cpfMask;
      }

      // CNPJ → alfanumérico
      return this.cnpjMask;
    }
  };
}


	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchproposal(this.proposal.value, this.currentPage, false);
	}

	searchproposal(proposta, page, isSearch) {
		if (isSearch) {
			this.orderby = "TipoProposta";
			this.sort = "asc";
			this.currentPage = 0;
		}

		this.proposalservice.search(this.token, proposta, this.orderby, this.sort, page).subscribe(result => {
			this.resultados = result.Result;
			this.total = result.Count;

			if (this.total > 0) {
				setTimeout(() => {
					$('html, body').animate({
						scrollTop: $('#resultHeader').offset().top
					}, 500);
				}, 500);
			}
		});
	}

	getClientGroupList(proposalID, proposalCod, accountClient, currentClientDocument, segmentoID) {
		if (this.permissoes['GrupoEconomico_Acesso']) {
			this.proposalservice.getEconomicGroups(accountClient, null).subscribe(result => {
				if (result.Result) {
					this.tempGroup = result.Result;
					this.getUserProfileByClient(proposalID, proposalCod, accountClient, currentClientDocument, segmentoID);
				}
			}, error => {
				this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
			});
		}
	}

	getUserProfileByClient(proposalID, proposalCod, accountClient, currentClientDocument, segmentoID) {
		this.proposalservice.getUserProfileByClient(accountClient).subscribe(result => {
			if (result.Success) {
				let disposable = this.dialogService.addDialog(ProposalViewModalComponent, {
					proposalID: proposalID,
					proposalCod: proposalCod,
					accountClientID: accountClient,
					currentClientDocument: currentClientDocument,
					tempGroup: this.tempGroup,
					profileUser: result.Result,
					segmentoID: segmentoID
				},
				{
					backdropColor: 'rgba(0, 0, 0, 0.5)'
				}).subscribe((isConfirmed) => {
					// Do nothing.
				});
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			return false;
		});
	}

	openProposalView(proposalID, proposalCod, accountClient, currentClientDocument, segmentoID) {
		this.getClientGroupList(proposalID, proposalCod, accountClient, currentClientDocument, segmentoID);
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchproposal(this.proposal.value, $event, false);
	}

	exportproposal(proposta) {
		this.proposalservice.export(this.token, proposta).subscribe(resultBlob => {
			if (resultBlob)
				saveAs(resultBlob, "relatorio_proposta.xlsx");
		});
	}

	ClientTypes() {
		this.proposalservice.getClientTypes(this.token).subscribe(result => {
			this.clientTypes = result.Result;
		});
	}

	SegmentTypes() {
		this.proposalservice.getSegmentTypes(this.token).subscribe(result => {
			this.segmentTypes = result.Result;
		});
	}

	getStatus() {
		this.proposalservice.getStatus(this.token).subscribe(result => {
			this.statusTypes = result.Result;
		});
	}

	getCTC() {
		this.proposalservice.getCTC(this.token).subscribe(result => {
			this.ctcs = result.Result;
		});
	}

	getGC() {
		this.proposalservice.getGC(this.token).subscribe(result => {
			this.gcs = result.Result;
		});
	}

	getDirector() {
		this.proposalservice.getDirector(this.token).subscribe(result => {
			this.directors = result.Result;
		});
	}

	getAnalyst() {
		this.proposalservice.getAnalyst(this.token).subscribe(result => {
			this.analysts = result.Result.filter((e, i) => result.Result.findIndex(a => a['Nome'] === e['Nome']) === i);
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/report/component/proposal/proposal.component.ts